import get from 'lodash/get';

/**
 * Splits an object with n keys in to two columns
 * @param {object} o1
 * @param {object} o2
 * @param {object} intl
 */
export function transformDataColumns(o1, o2, intl, sort = true) {
  let data = Object.keys(o1)
    .map(key => {
      const value = get(o2, `${key}.value`);
      return value && key;
    })
    .filter(item => item);

  if (intl) {
    data = data.map(key => intl.formatMessage(o1[key]));
  }

  if (sort) {
    data.sort();
  }

  return [data.splice(0, Math.ceil(data.length / 2)), data];
}
